import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomTab from './../../common/CustomTab/CustomTab';
import UserTestList from './UserTestList/UserTestList';

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentIndex: 0
		}
		this.takeIndex = this.takeIndex.bind(this);
		this.takeTestPage = this.takeTestPage.bind(this);
	}

	componentDidMount() {
		this.props.dashContext.getDashList();
		this.props.dashContext.getFeedbackSalesList();
	}

	componentWillUnMount() {
		this.props.dashContext.clearDashList();
		this.props.commonContext.updateLoaderMsg('');
	}

	takeIndex(val) {
		this.setState({ currentIndex: val });
	}

	takeTestPage(user_id, module_id, attempts) {
		const array = attempts.filter(val => val.complete === 'Y');

		this.props.history.replace({
			pathname: 'mockexam',
			state: {
				user_id, module_id, attempt: array.length + 1
			}
		})
	}

	render() {

		const { history } = this.props;
		const { testList, feedbackSalesList } = this.props.dashContext;
		const { currentIndex } = this.state;

		let tabHeading = [];
		for (let i = 0; i < testList.length; i++) {
			let data = {
				id: testList[i].course_id,
				name: testList[i].course_name,
			}
			tabHeading.push(data);
		}

		return (
			<div className='Dashboard'>
				<CustomTab
					tabHeading={tabHeading}
					tabContent={[<UserTestList 
									history={history} 
									takeTestPage={this.takeTestPage} 
									details={testList[currentIndex]} 
									salesFeedbackList={feedbackSalesList}/>]}
					takeIndex={this.takeIndex}
				/>
			</div>
		);
	}
}

Dashboard.propTypes = {
	history: PropTypes.instanceOf(Object),
	match: PropTypes.instanceOf(Object),
	dashContext: PropTypes.instanceOf(Object),
	loginDetails: PropTypes.instanceOf(Object)
};

Dashboard.defaultProps = {
	history: {},
	match: {},
	dashContext: {},
	loginDetails: {}
};

export default Dashboard;


// const Dashboard = ({history, match, loginDetails, dashContext}) => {

// 	const tabHeading = ['Course 1', 'Course 2'];

// 	const tabContent = [
// 		<UserTestList history={history} />
// 	];

// 	return (
// 		<div className="Dashboard">
// 			<CustomTab
// 				tabHeading={tabHeading}
// 				tabContent={tabContent}
// 			/>
// 		</div>
// 	);
// }


// WEBPACK FOOTER //
// ./components/Dashboard/Dashboard.js